import { useEffect, useState } from "react";

const DURATION_MS = 24 * 60 * 60 * 1000;
const STORAGE_KEY = "plano40_offer_deadline";

const getDeadline = () => {
  const now = Date.now();
  try {
    const saved = Number(localStorage.getItem(STORAGE_KEY));
    if (saved && saved > now) return saved;
    const next = now + DURATION_MS;
    localStorage.setItem(STORAGE_KEY, String(next));
    return next;
  } catch {
    return now + DURATION_MS;
  }
};

export const pad = (n) => String(n).padStart(2, "0");

export const useCountdown = () => {
  const [deadline] = useState(getDeadline);
  const [remaining, setRemaining] = useState(deadline - Date.now());

  useEffect(() => {
    const id = setInterval(() => setRemaining(Math.max(0, deadline - Date.now())), 1000);
    return () => clearInterval(id);
  }, [deadline]);

  return {
    hours: Math.floor(remaining / 3_600_000),
    minutes: Math.floor((remaining % 3_600_000) / 60_000),
    seconds: Math.floor((remaining % 60_000) / 1000),
  };
};
